import React, { Component } from 'react';
import styled from "styled-components"
import { Table, Spin, message } from 'antd'
// import Dashboard from '@/components/HistoryLogsByIMEI/Dashboard.jsx'
import Filter from '@/components/HistoryLogsByIMEI/Filter.jsx'
import HistoryAPi from '@/API/history'
import dayjs from 'dayjs'
import { withTranslation } from 'react-i18next';

const DataTable = styled(Table)`
  margin-top:20px;
`

const Div = styled.div`
  padding:0 20px 20px;
`

class HistoryLogsByIMEI extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statistics: null,
      loading: false,
      historyLogsList: [],
      filter: {},
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        size: 'small',
        showTotal: (total) => (this.props.t('Total items', { total: total }))
      }
    };
  }
  filterChange = (key, value) => {
    let field = {}
    field[key] = value
    this.setState(prevState => ({
      filter: {
        ...prevState.filter,
        ...field
      }
    }))
  }
  exp = () => {
    const { filter, pagination } = this.state
    const params = {
      imei: filter.IMEI,
      pageIndex: pagination.current - 1,
      pageSize: pagination.pageSize
    }
    HistoryAPi.exportStatusStatistics(params).then((res) => {
      message.success(res)
    })
  }
  search = (clear) => {
    const { filter } = this.state
    this.setState((prevState) => ({
      pagination: {
        current: 1,
        ...prevState.pagination
      }
    }))
    if (clear) {
      this.setState({ filter: { ...filter } }, () => {
        this.getData()
      })
    } else {
      this.getData()
    }
  }
  clear = () => {
    this.setState({ historyLogsList: [], statistics: null })
  }
  getData = () => {
    const { filter, pagination } = this.state
    const { t } = this.props
    if (filter.IMEI) {
      HistoryAPi.getImeiSingleStatusStatistics({
        imei: filter.IMEI,
        pageIndex: pagination.current - 1,
        pageSize: pagination.pageSize
      }).then((res) => {
        if (res.data.length === 0) {
          return message.warning(t("not find"))
        }
        // this.setState({ historyLogsList: res.data, total: res.totalCount })
        this.setState({
          historyLogsList: res.data,
          pagination: Object.assign({}, {
            total: res.totalCount,
            ...this.pagination
          })
        }
        )
      })
    } else {
      this.setState({ historyLogsList: [] })
      message.warning(t("Enter IMEIs"))
    }
  }
  handleTableChange = (pagination) => {
    this.setState({
      pagination: pagination,
    }, () => {
      this.getData()
    });
  }
  render() {
    const { statistics, loading, historyLogsList, pagination } = this.state;
    const { t } = this.props;
    const columns = [
      {
        title: t("Model"),
        dataIndex: 'productName'
      },
      {
        title: t('Marketing Name'),
        dataIndex: 'marketingName'
      },
      {
        title: t("IMEI"),
        dataIndex: 'imei'
      },
      {
        title: t('Status'),
        dataIndex: 'status'
      },
      {
        title: t('Create Time'),
        dataIndex: 'createTime',
        render: (text) => (dayjs(text).format('YYYY-MM-DD HH:mm:ss'))
      },
      {
        title: t('Operator'),
        dataIndex: 'userName'
      },
      {
        title: t('Operation'),
        dataIndex: 'operation'
      }
    ];
    return (
      <div>
        {/* {
          statistics ? <Dashboard data={statistics}></Dashboard> : null
        } */}
        <Filter filterChange={this.filterChange} search={this.search} clear={this.clear} exp={this.exp}></Filter>
        <Div>
          <Spin spinning={loading}>
            <DataTable columns={columns} dataSource={historyLogsList} rowKey="index" pagination={pagination} onChange={this.handleTableChange}></DataTable>
          </Spin>
        </Div>
      </div>
    )
  }
}

export default withTranslation()(HistoryLogsByIMEI);